import { Modal, ModalFuncProps } from 'antd';

const { info, confirm, success, error } = Modal;

const baseProps: ModalFuncProps = {
  centered: true,
  closable: true,
  width: 650,
};

export const showInfoModal = (props: ModalFuncProps) => {
  return info({
    okText: 'Entendi',
    ...baseProps,
    ...props,
  });
};

export const showConfirmModal = (props: ModalFuncProps) => {
  return confirm({
    okText: props.okText || 'Sim',
    cancelText: props.okText || 'Não',
    maskClosable: true,
    ...baseProps,
    ...props,
  });
};

export const showSuccessModal = (props: ModalFuncProps) => {
  return success({
    okText: 'OK',
    maskClosable: true,
    ...baseProps,
    ...props,
  });
};

export const showErrorModal = (props: ModalFuncProps) => {
  return error({
    okText: 'OK',
    maskClosable: true,
    ...baseProps,
    ...props,
  });
};
